module.exports = function getResource(label, vars = []) {
    const resources = {
        viewFullSizeLabel: 'View Full Size',
        viewDetailsLabel: 'View Details'
    };
    return resources[label];
};
